import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CrmNoteService {


  url = environment.serverAPI9 + "/api/crmNotes";

  url1 = environment.serverAPI9 + "/api/companyNotes";

  url2 = environment.serverAPI9 + "/api/dealsNotes";

   url5 = environment.serverAPI9 + "/api/document/common";


  constructor(private http: HttpClient) { }

  getAllNote(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllNoteDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getNoteById(leadId: number): Observable<Object> {
    return this.http.get(`${this.url}/${leadId}`);
  }

  addOrEditNote(Note: any, type: any): Observable<Response[]> {
    if (type == 1) {
      return this.http.post<Response[]>(`${this.url}`, Note);
    } else if (type == 2) {
      return this.http.post<Response[]>(`${this.url1}`, Note);
    }else if (type == 5) {
      return this.http.post<Response[]>(`${this.url5}`, Note);
    } 
    
    else {
      return this.http.post<Response[]>(`${this.url2}`, Note);
    }


  }

  NoteSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllNoteByLeadId(leadId: number,type:any): Observable<Object> {
   
    if (type == 1) {
      return this.http.get(`${this.url}/lead/${leadId}`);
    } else if (type == 2) {
      return this.http.get(`${this.url1}/lead/${leadId}`);
    } else {
      return this.http.get(`${this.url2}/lead/${leadId}`);
    }
  }


  deleteByNoteId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }

  saveReply(reply: any): Observable<Object> {
    return this.http.post(`${this.url}/reply`, reply);
  }
}
